import React, { useState, useEffect} from 'react';
import * as Calc from './libraries/Calc.js';

function CalSupportSavings(props) {
  const [tickets,setTickets] = useState(props.tickets);
  const [cost,setCost] = useState(props.cost);
  const [AIRate,setAIRate] = useState(10);

  //const [newSupportCost,setNewSupportCost] = useState(0);
  
  const [result,setResult] = useState(0);
  const average_AI_rate = 80;
  
  useEffect(()=>{
    //console.log(cost);
    //let new_result = Math.abs(tickets * cost * (props.rate/100-1));
    let new_result = Math.abs( tickets * cost * ( (average_AI_rate/100)-(AIRate/100) )/(1-(AIRate/100) ) );
    if( AIRate>=80 ) new_result = 0;


    //let new_support_cost = ((tickets*12*cost)-(new_result*12))/12;

    //setNewSupportCost(new_support_cost);
    
    setResult(new_result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[cost,tickets,AIRate]);

  return (
    <div className="row d-flex justify-content-center CalSupportSavings">
      <div className="col-12 col-lg-6 pe-lg-0">
        <div className="card card_calc">
          <div className="card-body position-relative mt-2">
            <form>
              <div className="position-relative">
                <label htmlFor="CalSupportSavings_range_tickets" className="form-label d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bolder">Annual Support Tickets:</h2>
                    <div className="h5 mb-0 d-none"><small>Average number of customer support tickets per month</small></div>
                  </div>
                  <div>
                    <input type="text" className="form-control text-end" placeholder="Tickets" value={tickets}  onChange={(e)=>setTickets(e.target.value)} style={{ width: '120px' }}/>
                    {/*{Calc.formatNumber(tickets)}   style={{ width: '120px' }}*/}
                  </div>
                </label>
                <input type="range" className="form-range" id="CalSupportSavings_range_tickets" placeholder="Tickets" min={100} max={500000} step="500" value={tickets}  onChange={(e)=>setTickets(e.target.value)}/>
              </div>



              <div className="my-4 position-relative">
                <label htmlFor="CalSupportSavings_range_cost" className="form-label d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bolder">Cost Per Ticket:</h2>
                    <div className="h5 mb-0 d-none"><small>Average cost to resolve a ticket</small></div>
                  </div>
                  {/*<div>{Calc.formatCurrency2(cost)}</div>*/}
                  <div className="input-group mb-0" style={{ width: '150px' }}>
                    <span className="input-group-text">$</span>
                    <input type="text" className="form-control text-end" placeholder="Cost Per Ticket" value={cost} onChange={(e)=>setCost(e.target.value)}/>
                  </div>
                </label>
                <input type="range" className="form-range" id="CalSupportSavings_range_cost" placeholder="Cost Per Ticket" min="0.1" max="25" step="0.1" value={cost} onChange={(e)=>setCost(e.target.value)}/>
              </div>

              <div className="position-relative">
                <label htmlFor="CalSupportSavings_range_rate" className="form-label d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bolder">Self-Service Rate:</h2>
                    <div className="h5 mb-0 d-none"><small>Current self-service resolution rate</small></div>

                  </div>
                  <div>
                    <div className="input-group mb-0" style={{ width: '100px' }}>
                      <input type="text" className="form-control text-end" placeholder="Current Self Service" value={AIRate} onChange={(e)=>setAIRate(e.target.value)}/>
                      <span className="input-group-text">%</span>
                    </div>
                    
                    {/*
                    {AIRate}%
                    */}
                  </div>
                </label>
                <input type="range" className="form-range" id="CalSupportSavings_range_rate" placeholder="Cost Per Ticket" min="0" max="100" step="1" value={AIRate} onChange={(e)=>setAIRate(e.target.value)}/>
              </div>

              {/*
              <div className="row">
                <div className="col-12">
                  <h6 className="fw-bolder">Your Current Annual Support Cost: {Calc.formatCurrency(tickets*12*cost)}</h6>
                </div>
              </div>

              <div className="bottom_result">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="fw-bolder mb-0" style={{ fontSize: '32px', color: '#535252' }}>Annual Support Cost: </h6>
                  <h2 className="" style={{ fontSize: '75px', color: '#535252', fontWeight: '900' }}>${Calc.formatCurrency3(tickets*cost*(AIRate/100))}</h2>
                </div>
              </div>
              */}
             
              {/*
              <div className="bottom_result">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <h6 className="fw-bolder mb-0" style={{ fontSize: '32px', color: '#535252' }}>Annual Support Cost: </h6>
                  <h2 className="" style={{ fontSize: '75px', color: '#535252', fontWeight: '900' }}>${Calc.formatCurrency3(tickets*cost)}</h2>
                </div>
              </div>
              */}
             

              <div className="bottom_result">
                <div>
                  <h6 className="fw-bolder mb-0" style={{ fontSize: '25px', color: '#535252' }}>Annual Support Cost:</h6>
                  <h5 className="fw-bolder mb-0" style={{ fontSize: '80px', color: '#535252', fontWeight: '900' }}>${Calc.formatCurrency3(tickets*cost)}</h5>
                </div>
              </div>



              {/*
              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <div className="mb-3 position-relative">
                      <label htmlFor="costperticket" className="form-label form-label_3 lh-1">Current Self Service <br/>Resolution Rate:</label>
                      <input type="number" className="form-control" id="costperticket" min="0" max="100" value={AIRate} onChange={(e)=>setAIRate(e.target.value)}/>
                      <span className="symbol_percentage fw-bold">%</span>
                    </div>
                  </div>
                </div>
              </div>
              */}

            </form>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 ps-lg-0">
        <div className="card card_result">
          <div className="card-body position-relative mt-2">
            <div>
              <div className="card-title h2 fw-bolder" style={{ fontSize: '40px', color: '#fff' }}>
                LiveX AI Cost Savings
              </div>

              <div className="my-4">
                <h3 style={{ fontSize: '30px', color: '#fff' }} className="mb-0">Annual Tickets: {Calc.formatNumber(tickets)}</h3>
                <small style={{ fontSize: '20px',color: '#fff' }}>Average annual ticket volume</small>  
              </div>

              <div className="my-4">
                <div style={{ fontSize: '30px', color: '#fff' }} className="h3 mb-0">Resolve Tickets: <h3 className="d-inline fw-bolder" style={{ fontSize: '40px', color: '#fff' }}>{Calc.formatNumber(tickets*0.8)}</h3></div>
                <small style={{ fontSize: '20px',color: '#fff' }}>Number of tickets resolved with LiveX AI</small>  
              </div>

              {/*
              <div className="my-4">
                <h2 style={{ fontSize: '20px', color: '#fff' }} className="mb-0 fw-bolder">Savings: {Calc.formatCurrency(result*12)}</h2>
                <small style={{ fontSize: '0.6em',color: '#fff' }}>Annual savings with LiveX AI</small>  
              </div>
              */}

              {/*
              <div className="my-4">
                <h2 style={{ fontSize: '35px', color: '#FCBC6A' }} className="mb-3 fw-bolder">Savings:</h2>
              </div>

              <div className="bottom_result">
                <div className="col-12 d-lg-flex justify-content-lg-between align-items-center">
                  <div>
                    <h2 className="" style={{ fontSize: '75px', color: '#FCBC6A', fontWeight: '900' }}>${Calc.formatCurrency3(result)}</h2>
                  </div>
                  <div>
                    <button className="btn btn-sm btn-email d-none">Email Result</button>
                  </div>
                </div>
              </div>
              */}
              <div className="bottom_result">
                <div>
                  <h2 className="mb-0 fw-bolder" style={{ fontSize: '25px', color: '#ffb350' }}>Savings:</h2>
                  <h2 className="" style={{ fontSize: '75px', color: '#FCBC6A', fontWeight: '900' }}>${Calc.formatCurrency3(result)}</h2>
                </div>
              </div>

              {/*
              <h6 style={{ color: '#419bd1' }} className="fw-bold">Annual Ticket Volume: {Calc.formatNumber(tickets*12)}</h6>
              <h6 style={{ color: '#419bd1' }}>Current resolution rate:Avg. {Calc.formatNumber(tickets*12*(AIRate/100))} tickets annually</h6>
              <h6>Current yearly support cost: {Calc.formatCurrency(tickets*12*cost)}</h6>

              <h5 style={{ color: '#27978b' }} className="mt-4 fw-bold">With LiveX:</h5>
              <h5 style={{ color: '#27978b' }}>Resolution Avg. {Calc.formatNumber(tickets*12*0.8)} tickets annually</h5>
              <h6>(Based 80% Deflection Rate)</h6>
              <div className="d-flex align-items-center my-3">
                <span className="lh-1 align-middle result_label">Yearly<br/>Savings</span>
                <span className="ms-3"><h3 className="annually_saved result_result mb-0">{Calc.formatCurrency(result*12)}</h3></span>
              </div>
              <h6 style={{ color: '#27978b' }} className="fw-bold">New support cost: {Calc.formatCurrency(newSupportCost)}/month</h6>
              */}
             
              {/*
              <table className="table">
                <tbody>
                  <tr>
                    <td align="right" className="lh-1 align-middle result_label">Monthly<br/>Savings</td>
                    <td><h3 className="monthly_saved result_result mb-0">${result.toFixed(0)}</h3></td>
                  </tr>
                  <tr>
                    <td align="right" className="lh-1 align-middle result_label">Yearly<br/>Savings</td>
                    <td><h3 className="annually_saved result_result mb-0">${(result*12).toFixed(0)}</h3></td>
                  </tr>
                </tbody>
              </table>
              <Disclaimer/>
              */}

              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalSupportSavings;
